//通用函数
import smCom from './global/smCom.js';
//数字函数
import numHelper from './global/numHelper.js';
//时间函数
import timeHelper from './global/timeHelper.js';

//千牛
import zmCloudApi from './api/zmCloudApi.js';
//sm公共接口
import smCommon from './api/smCommon.js';

//尚米sell接口
import smSellApi from './api/smSellApi.js';
import newSmApi from './api/newSmApi.js';
import smCloudApi from './api/smCloudApi.js';

//电子价签接口
import smElabelApi from './elabelApi/smElabelApi.js';
import smElabelCom from './elabelApi/smElabelCom.js';

export default {

  smCom, //通用函数
  numHelper, //数字函数
  timeHelper, //时间函数
  zmCloudApi,
  smCommon,
  smSellApi, //尚米sell接口
  newSmApi,
  smCloudApi,
  smElabelApi,
  smElabelCom
}



//////////////////
// WEBPACK FOOTER
// ./common/api.js
// module id = null
// module chunks = 